export enum ConditionalStatusGroupRelations {
  trails = 'trails',
  conditionalStatuses = 'conditionalStatuses',
}
